<template>
	<div class="main-nav">
		<nav class="main-nav__wrapper">
			<SiteMenu />
		</nav>
	</div>
</template>

<script>
import SiteMenu from '@/site-components/site-menu/dynamic-site-menu';

export default {
	name: 'NavigationBar',
	props: {
		navigation: {
			type: Object,
			default: () => {}
		}
	},
	components: {
		SiteMenu
	}
};
</script>

<style lang="scss" scoped>
/**
	* Site Nav
    * Can use SCSS variables = TRUE
*/

.main-nav {
	background: $site-nav-bkgd;
	// -------
	// NOTE FOR DEV: this should only render on larger screens -- once the logic is implemented this style can be removed
	// -------
	@include mq($until: lg) {
		display: none;
	}
	// -- END NOTE --

	&__wrapper {
		@include contain(1200px);
	}
}
</style>
